import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const helpData = {
  Favourites: [
    {
      question: "What is Favourites?",
      answer: `• You can set a successful transaction as your favourite transaction!

• This allows you to repeat these transactions later with a single click.

• After every successful transaction, an option is provided to set it as a favourite.

• Maximum number of favourites that can be set is 15. However, if you try to set the 16th favourite, the oldest one will be deleted.`,
    },
    {
      question: "How can I use Favourites?",
      answer: `• Click on the "Favourites" section on the Home page.

• Repeat your transaction with the same or a new amount.

• By default, the previous amount is pre-filled, but you can modify it before submitting.`,
    },
  ],
};

const Favourites = ({ selectedSection = "LoadMoney" }) => {
  const questions = helpData[selectedSection] || [];
  const [openIndex, setOpenIndex] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const toggleAnswer = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <Box width="100%">
      {/* Top Banner */}
      <Box
        sx={{
          width: "100%",
          height: { xs: 180, sm: 220, md: 260 },
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 1, sm: 3 },
        }}
      >
        <Box
          component="img"
          src="/Assets/Favorite.jpg"
          alt="Profile illustration"
          sx={{
            width: "100%",
            maxWidth: 1000,
            height: "100%",
            objectFit: "cover",
            borderRadius: "0 0 10px 10px",
          }}
        />
      </Box>

      {/* FAQ Heading */}
      <Box mt={2} display="flex" justifyContent="center">
        <Typography
          variant={isMobile ? "h6" : "h5"}
          fontWeight="bold"
          color="black"
        >
          Favourite
        </Typography>
      </Box>

      {/* FAQ List */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "900px",
          mx: "auto",
          px: { xs: 1.5, sm: 2, md: 3 },
          mt: 2,
          py: 2,
        }}
      >
        <List disablePadding>
          {questions.map((item, index) => (
            <Box
              key={index}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                mb: 2,
                overflow: "hidden",
                boxShadow:
                  openIndex === index ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
                transition: "box-shadow 0.2s ease-in-out",
              }}
            >
              <ListItemButton
                onClick={() => toggleAnswer(index)}
                sx={{
                  borderBottom: "1px solid #eee",
                  px: 2,
                  py: 1.5,
                  borderRadius: 1,
                  backgroundColor:
                    openIndex === index ? "#e0f7fa" : "transparent",
                  "&:hover": {
                    backgroundColor:
                      openIndex === index ? "#b2ebf2" : "#f9f9f9",
                  },
                }}
              >
                <ListItemText primary={item.question} />
                {openIndex === index ? (
                  <ExpandMoreIcon sx={{ fontSize: 18 }} />
                ) : (
                  <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
                )}
              </ListItemButton>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Box px={3} py={2} bgcolor="#fafafa">
                  <Typography
                    variant="body2"
                    sx={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}
                  >
                    {item.answer}
                  </Typography>
                </Box>
              </Collapse>
            </Box>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default Favourites;
